import React, { useState, useEffect, useCallback } from 'react';
import { ArrowRight } from 'lucide-react';
import './Hero.css';
import { useNavigate } from 'react-router-dom';

import background1 from '../assets/Background1_4k.webp';
import background2 from '../assets/Background2.webp';
import background3 from '../assets/Background3_4k.webp';

const slides = [
  {
    src: background1,
    eyebrow: 'Opulent Architecture',
    title: <>Crafting Spaces<br /><em>Beyond Ordinary</em></>,
    subtitle: 'Where precision meets grandeur — bespoke interiors and architecture that transcend the expected.',
  },
  {
    src: background2,
    eyebrow: 'Interior Excellence',
    title: <>Luxury Defined<br /><em>by Detail</em></>,
    subtitle: 'Every material, every light, every surface — curated for a life of refined elegance.',
  },
  {
    src: background3,
    eyebrow: 'End-to-End Design',
    title: <>Your Vision,<br /><em>Perfected</em></>,
    subtitle: 'From concept to completion — we craft environments that inspire, endure, and elevate.',
  },
];

const Hero = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [loaded, setLoaded] = useState({});

  // Preload all slides
  useEffect(() => {
    slides.forEach((slide) => {
      const img = new Image();
      img.src = slide.src;
      img.onload = () => setLoaded(prev => ({ ...prev, [slide.src]: true }));
    });
  }, []);

  // Auto-advance
  useEffect(() => {
    const id = setInterval(() => setActiveIndex(i => (i + 1) % slides.length), 5500);
    return () => clearInterval(id);
  }, []);

  const goTo = useCallback((i) => setActiveIndex(i), []);

  return (
    <section id="home" className="hero-section">
      {/* Background slides */}
      <div className="hero-bg">
        {slides.map((slide, i) => (
          <div
            key={i}
            className={`hero-slide ${i === activeIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.src})` }}
            aria-hidden={i !== activeIndex}
          />
        ))}
        <div className="hero-overlay" />
      </div>

      {/* Content */}
      <div className="hero-content-wrap" key={activeIndex}>
        <p className="hero-eyebrow">{slides[activeIndex].eyebrow}</p>
        <h1 className="hero-title">{slides[activeIndex].title}</h1>
        <p className="hero-subtitle">{slides[activeIndex].subtitle}</p>
        <div className="hero-actions">
          <button
            className="btn-gold"
            onClick={() => navigate('/start-project')}
          >
            Start Your Project <ArrowRight size={16} />
          </button>
          <button
            className="btn-outline-ivory"
            onClick={() => navigate('/portfolio')}
          >
            View Portfolio
          </button>
        </div>
      </div>

      {/* Slide dots */}
      <div className="hero-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`hero-dot ${i === activeIndex ? 'active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      {/* Scroll indicator */}
      <div className="hero-scroll">
        <span>Scroll</span>
        <div className="hero-scroll-line" />
      </div>
    </section>
  );
};

export default Hero;
